<template>
  <span class="relative inline-flex items-center">
    <component
      :is="iconComponent"
      v-bind="$attrs"
      :class="['icon', iconSize, { 'icon-highlighted': highlighted }]"
    />
    <div
      v-if="highlighted"
      class="absolute right-[12%] top-[19%] bg-theme-feedback-negative rounded-full h-[32%] w-[32%]"
    />
  </span>
</template>

<script lang="ts">
import ArrowLeft from "@/assets/theme/icons/arrow-left.svg?component";
import ArrowRight from "@/assets/theme/icons/arrow-right.svg?component";
import BinBoxArrowUp from "@/assets/theme/icons/bin-box-arrow-up.svg?component";
import Book from "@/assets/theme/icons/book.svg?component";
import Bookmark from "@/assets/theme/icons/bookmark.svg?component";
import BookmarkFavorite from "@/assets/theme/icons/bookmark-favorite.svg?component";
import CalendarSchedule from "@/assets/theme/icons/calendar-schedule.svg?component";
import CalendarScheduleSm from "@/assets/theme/icons/calendar-schedule-sm.svg?component";
import CheckCircle from "@/assets/theme/icons/check-circle.svg?component";
import CheckDocument from "@/assets/theme/icons/check-document.svg?component";
import ChevronDown from "@/assets/theme/icons/chevron-down.svg?component";
import ChevronDown2 from "@/assets/theme/icons/chevron-down-2.svg?component";
import ChevronLeft from "@/assets/theme/icons/chevron-left.svg?component";
import ChevronRight from "@/assets/theme/icons/chevron-right.svg?component";
import ChevronUp from "@/assets/theme/icons/chevron-up.svg?component";
import CloseBlack from "@/assets/theme/icons/icon-close-black.svg?component";
import Cross from "@/assets/theme/icons/cross.svg?component";
import DeliveryTruckPin from "@/assets/theme/icons/delivery-truck-pin.svg?component";
import Devolucion from "@/assets/theme/icons/devolver.svg?component";
import DocumentAlert from "@/assets/theme/icons/document-alert.svg?component";
import DocumentEditPen from "@/assets/theme/icons/document-edit-pen.svg?component";
import Documents from "@/assets/theme/icons/documents.svg?component";
import DownloadArrow from "@/assets/theme/icons/download-arrow.svg?component";
import Email from "@/assets/theme/icons/email.svg?component";
import Eye from "@/assets/theme/icons/eye.svg?component";
import Eye2 from "@/assets/theme/icons/eye2.svg?component";
import EyeCross from "@/assets/theme/icons/eye-cross.svg?component";
import EyePedido from "@/assets/theme/icons/icon-eye-pedido.svg?component";
import Filter from "@/assets/theme/icons/filter.svg?component";
import Gears from "@/assets/theme/icons/gears.svg?component";
import Glasses from "@/assets/theme/icons/glasses.svg?component";
import GraduationCap from "@/assets/theme/icons/graduation-cap.svg?component";
import Home from "@/assets/theme/icons/home.svg?component";
import IconError from "@/assets/theme/icons/icon-i-red.svg?component";
import Info from "@/assets/theme/icons/info.svg?component";
import Info2 from "@/assets/theme/icons/info2.svg?component";
import InfoFilled from "@/assets/theme/icons/info-filled.svg?component";
import Menu from "@/assets/theme/icons/menu.svg?component";
import Minus from "@/assets/theme/icons/minus.svg?component";
import MinusCircle from "@/assets/theme/icons/minus-circle.svg?component";
import Notifications from "@/assets/theme/icons/notifications.svg?component";
import Objects from "@/assets/theme/icons/objects.svg?component";
import PaperPlane from "@/assets/theme/icons/paper-plane.svg?component";
import Pen from "@/assets/theme/icons/pen.svg?component";
import Phone from "@/assets/theme/icons/phone.svg?component";
import Plus from "@/assets/theme/icons/plus.svg?component";
import PlusCircle from "@/assets/theme/icons/plus-circle.svg?component";
import PlusSm from "@/assets/theme/icons/plus-sm.svg?component";
import Printer from "@/assets/theme/icons/printer.svg?component";
import Refresh from "@/assets/theme/icons/refresh.svg?component";
import Search from "@/assets/theme/icons/search.svg?component";
import Settings from "@/assets/theme/icons/settings.svg?component";
import SettingsNav from "@/assets/theme/icons/settings-nav.svg?component";
import Share from "@/assets/theme/icons/share.svg?component";
import SignOut from "@/assets/theme/icons/sign-out.svg?component";
import StarFavorite from "@/assets/theme/icons/star-favorite.svg?component";
import ThumbsUp from "@/assets/theme/icons/thumbs-up.svg?component";
import TimeClock from "@/assets/theme/icons/time-clock.svg?component";
import Times from "@/assets/theme/icons/times.svg?component";
import Trash from "@/assets/theme/icons/trash.svg?component";
import TriangleDown from "@/assets/theme/icons/triangle-down.svg?component";
import TriangleLeft from "@/assets/theme/icons/triangle-left.svg?component";
import TriangleRight from "@/assets/theme/icons/triangle-right.svg?component";
import TriangleUp from "@/assets/theme/icons/triangle-up.svg?component";
import Upload from "@/assets/theme/icons/upload.svg?component";
import UrgentEmails from "@/assets/theme/icons/urgent-emails.svg?component";
import UserDefault from "@/assets/theme/icons/user-default.svg?component";
import WarningNotification from "@/assets/theme/icons/warning-notification.svg?component";
import WarningNotification2 from "@/assets/theme/icons/warning-notification-2.svg?component";
import WarningRounded from "@/assets/theme/icons/warning-rounded.svg?component";
import Whatsapp from "@/assets/theme/icons/whatsapp.svg?component";
import Wrench from "@/assets/theme/icons/wrench.svg?component";

export const icons = {
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "bin-box-arrow-up": BinBoxArrowUp,
  book: Book,
  bookmark: Bookmark,
  "bookmark-favorite": BookmarkFavorite,
  "calendar-schedule": CalendarSchedule,
  "calendar-schedule-sm": CalendarScheduleSm,
  "check-circle": CheckCircle,
  "check-document": CheckDocument,
  "chevron-down": ChevronDown,
  "chevron-down-2": ChevronDown2,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-up": ChevronUp,
  "close-black": CloseBlack,
  cross: Cross,
  "delivery-truck-pin": DeliveryTruckPin,
  "devolucion-caja": Devolucion,
  "document-alert": DocumentAlert,
  "document-edit-pen": DocumentEditPen,
  documents: Documents,
  "download-arrow": DownloadArrow,
  email: Email,
  eye: Eye,
  eye2: Eye2,
  "eye-cross": EyeCross,
  "eye-pedido": EyePedido,
  filter: Filter,
  gears: Gears,
  glasses: Glasses,
  "graduation-cap": GraduationCap,
  home: Home,
  "icon-error": IconError,
  info: Info,
  info2: Info2,
  "info-filled": InfoFilled,
  menu: Menu,
  minus: Minus,
  "minus-circle": MinusCircle,
  notifications: Notifications,
  objects: Objects,
  "paper-plane": PaperPlane,
  pen: Pen,
  phone: Phone,
  plus: Plus,
  "plus-circle": PlusCircle,
  "plus-sm": PlusSm,
  printer: Printer,
  refresh: Refresh,
  search: Search,
  settings: Settings,
  "settings-nav": SettingsNav,
  share: Share,
  "sign-out": SignOut,
  "star-favorite": StarFavorite,
  "thumbs-up": ThumbsUp,
  "time-clock": TimeClock,
  times: Times,
  trash: Trash,
  "triangle-down": TriangleDown,
  "triangle-left": TriangleLeft,
  "triangle-right": TriangleRight,
  "triangle-up": TriangleUp,
  upload: Upload,
  "urgent-emails": UrgentEmails,
  "user-default": UserDefault,
  "warning-notification": WarningNotification,
  "warning-notification-2": WarningNotification2,
  "warning-rounded": WarningRounded,
  whatsapp: Whatsapp,
  wrench: Wrench,
} as const;

export type IconName = keyof typeof icons;
export type IconSize = "sm" | "md" | "lg";
</script>

<script setup lang="ts">
import { computed } from "vue";

defineOptions({ name: "Icon" });

const props = withDefaults(
  defineProps<{ name: IconName; size?: IconSize; highlighted?: boolean }>(),
  { size: "md", highlighted: false },
);

const iconComponent = computed(() => icons[props.name] ?? null);
const iconSize = computed(() => `icon-${props.size}`);
</script>

<style scoped>
.icon {
  display: inline-block;
  flex-shrink: 0;
  flex-grow: 0;

  &[fill="black"],
  & :global([fill="black"]) {
    fill: currentColor;
  }

  &[stroke="black"],
  & :global([stroke="black"]) {
    stroke: currentColor;
  }
}

.icon-sm {
  width: 1rem;
  height: 1rem;
}

.icon-md {
  width: 1.5rem;
  height: 1.5rem;
}

.icon-lg {
  width: 2rem;
  height: 2rem;
}
</style>
